import {reducers as snackbarNotificationsReducers} from '../../components/SnackbarNotifications'
import {reducers as decryptContainerReducers} from '../../components/DecryptContainer'
import {reducers as recoveryContainerReducers} from '../../components/RecoveryContainer'

export default {
  ...snackbarNotificationsReducers,
  ...decryptContainerReducers,
  ...recoveryContainerReducers 
}
